<template>
    <iframe
      title="IframeWidgetCode"
      src="https://www.primcomortgage.com/calculator/iframe-widget?HighchartColumnInterest=262526&HighchartColumnPrincipal=85a3b3&HighchartPieInterest=262526&HighchartPiePrincipal=85a3b3&HighchartPieInsurance=658693&HighchartPieMortgageInsurance=dddad7&ButtonColor=85a3b3&HighlightTextColor=85a3b3&HighlightTextColorLight=85a3b3&HeaderColor=85a3b3&NavigateMode=true&CalcMode=Mortgage&Footnote=true&AmortTab=true&lo=false&lo-name= &lo-title=&lo-nmls=&lo-location=, &lo-email=&lo-phone=&lo-imageurl=&lo-applynow=&lo-mysite=&lo-logo="
      width="100%"
      height="1000"
      frameborder="0"
      @load="onIframeLoad"
    ></iframe>
  </template>
  
  <script>
  export default {
    methods: {
      onIframeLoad() {
        console.log("Iframe fully loaded");
        this.$emit("loaded");
      }
    }
  };
  </script>